import { Page, PageHeader } from '@/components/layout/Page';
import { ApplicationsPanel } from '../components/ApplicationsPanel';

export function CareersApplicationsPage() {
  return (
    <Page>
      <PageHeader
        title="Applications"
        description="Review responses from the public Jobs page and open each candidate's CRM profile."
      />
      <ApplicationsPanel />
    </Page>
  );
}
